import CultivoMaleza from 'components/CultivoMaleza'

export default CultivoMaleza
